import { Tooltip, Typography } from '@neo4j-ndl/react';
import { InformationCircleIconOutline } from '@neo4j-ndl/react/icons';

export const InformationIconWithTooltip = ({
  tooltip,
  isPortaled = true,
}: {
  tooltip: string;
  isPortaled?: boolean;
}) => (
  <Tooltip type="simple" isPortaled={isPortaled}>
    <Tooltip.Trigger aria-label="Describe configuration item">
      <InformationCircleIconOutline className="text-palette-neutral-text-weaker ml-1 h-4 w-4" />
    </Tooltip.Trigger>
    <Tooltip.Content>
      <Typography variant="body-medium">{tooltip}</Typography>
    </Tooltip.Content>
  </Tooltip>
);
